import React, { useEffect, useState } from "react";
import { Snackbar as MuiSnackbar, Grow, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

function GrowTransition(props) {
  return <Grow {...props} />;
}

const SnackbarComp = ({
  open,
  message,
  autoHideDuration = 4000,
  onClose,
  background
}) => {
  const [isOpen, setIsOpen] = useState(open);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const handleClose = (_, reason) => {
    if (reason === "clickaway") return;
    setIsOpen(false);
    onClose?.();
  };

  return (
    <MuiSnackbar
      open={isOpen}
      onClose={handleClose}
      message={
        <Box
          sx={{
            backgroundColor:
              background === "success" ? "#558363" : "#9F4223",
            color: "#FEFEFE",
            px: 2,
            py: 1.2,
            borderRadius: "8px",
            fontSize: "14px",
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            minWidth: "280px",
          }}
        >
          {message}
          <IconButton
            aria-label="close"
            color="inherit"
            onClick={handleClose}
            sx={{ ml: 1, p: 1 }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      }
      TransitionComponent={GrowTransition}
      autoHideDuration={autoHideDuration}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      ContentProps={{
        sx: {
          background: "transparent",
          boxShadow: "none",
          p: 0,
        },
      }}
      // ✅ Force the Snackbar portal to be on top of everything
      sx={{
        zIndex: 99999,
        position: "fixed",
      }}
    />
  );
};

export default SnackbarComp;
